var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-header'),_c('app-menu'),_c('v-main',[_c('v-container',[_c('router-view',{attrs:{"name":"main"}})],1)],1),_c('v-footer',{attrs:{"app":""}},[_vm._v(" Tutti i diritti sono riservati © COPYRIGHT 2022 KILAB - Aneggi Alessandro ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }